var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"images-loaded",rawName:"v-images-loaded:on.progress",value:(_vm.imagesLoaded),expression:"imagesLoaded",arg:"on",modifiers:{"progress":true}}],ref:"container",staticClass:"gallery-stack"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }